/**
 * @file
 */

import { customValidationInit, aspControlValidationInit } from "@/common/validation/init.js";

export function InitializeSecureBorrowerRepaymentOptionsIDRstep3Page() {
  customValidationInit(true);
  aspControlValidationInit();
};
